var urlArray = ["https://www.birdfy.com/pages/map-policy","https://www.birdfy.com/policies/privacy-policy"]
var currentURL = window.location.href;
// 检查当前地址是否在数组中
if (urlArray.includes(currentURL)) {
  // 如果匹配，找到id为noindexContainer的元素
  var noindexContainer = document.getElementById("noindexContainer");

  // 添加属性content="noindex"
  if (noindexContainer) {
    noindexContainer.setAttribute("content", "noindex");
    console.log("Noindex attribute added to #noindexContainer");
  } else {
    console.error("Element with ID 'noindexContainer' not found.");
  }
}
